
<template>
  <div>
    <div style="background-color:white; margin-top: 5%; text-align: center;">
      <div class="content-center">
        <div class="container">
          <div class="row ">
            <div class="content-center col-md-8  ml-auto mr-auto ">                  
              <H1><small>Freight Bill :</small> {{ fb.BILL_NUMBER }}</H1>
              <h3><small>[{{ status[0].STATUS_CODE }}]</small> : <b>{{ status[0].SHORT_DESCRIPTION }}</b></h3>

              <!-- <div class="ml-auto mr-auto  col-md-6">Documents: --future use--</div> -->
              <div class="row ">
                <div class=" col-md-4">
                  <div
                    class="image-container img-raised img-radius city text-left"
                    style="min-height:120px"
                  >
                    <h5 class="mb-2 font-weight-bold text-uppercase">
                      SHIPPER
                    </h5>
                    <div class="">
                      <b>{{ fb.ORIGNAME }}</b><br>
                      {{ fb.ORIGADDR1 }},{{ fb.ORIGCITY }},{{ fb.ORIGPROV }}<br>
                      Pickup : <br> <span style="color:dodgerblue;font-weight:bold">{{ fb.PICK_UP_BY }} </span> to <span style="color:dodgerblue;font-weight:bold"> {{ fb.PICK_UP_BY_END }} </span>
                    </div>
                    <br>
                    <hr>
                    <br>
                    <h5 class="mb-2 font-weight-bold text-uppercase text-left">
                      CONSIGNEE
                    </h5>
                    <div class="">
                      {{ fb.DESTNAME }}<br>
                      {{ fb.DESTADDR1 }},{{ fb.DESTCITY }},{{ fb.DESTPROV }}<br>
                      Delivery : <br> <span style="color:dodgerblue;font-weight:bold"> {{ fb.DELIVER_BY }} </span> to <span style="color:dodgerblue;font-weight:bold"> {{ fb.DELIVER_BY_END }} </span>
                    </div>  
                                                                                                
                    <br>
                    <hr>
                    <br>
                    <h5 class="mb-2 font-weight-bold text-uppercase text-left">
                      FREIGHT DETAILS
                    </h5>
                    <div
                      v-for="item in tldtl"
                      :key="item.ID || item.DESCRIPTION || i"
                      class=""
                    >
                      <span v-if="item.COMMODITY">COMMODITY : <span style="color:dodgerblue;font-weight:bold">{{ item.COMMODITY }} <br> </span></span>
                      <span v-if="item.DESCRIPTION">DESCRIPTION : <span style="color:dodgerblue;font-weight:bold">{{ item.DESCRIPTION }} <br> </span></span>
                      <span v-if="item.PALLETS>0">PALLETS : <span style="color:dodgerblue;font-weight:bold">{{ item.PALLETS }} <br> </span></span>
                      <span v-if="item.PIECES>0">PIECES : <span style="color:dodgerblue;font-weight:bold">{{ item.PIECES }} {{ item.PIECES_UNITS }} <br></span></span>
                      <span v-if="item.LENGTH_1>0">LENGTH :  <span style="color:dodgerblue;font-weight:bold">{{ item.LENGTH_1 }} {{ item.LENGTH_UNITS }} <br></span></span>
                      <span v-if="item.HEIGHT>0">HEIGHT : <span style="color:dodgerblue;font-weight:bold">{{ item.HEIGHT }} {{ item.HEIGHT_UNITS }} <br></span></span>
                      <span v-if="item.WIDTH>0">WIDTH : <span style="color:dodgerblue;font-weight:bold">{{ item.WIDTH }} {{ item.WIDTH_UNITS }} <br></span></span>
                      <span v-if="item.CUBE>0">CUBE : <span style="color:dodgerblue;font-weight:bold">{{ item.CUBE }} {{ item.CUBE_UNITS }} <br></span></span>
                      <span v-if="item.WEIGHT>0">WEIGHT : <span style="color:dodgerblue;font-weight:bold">{{ item.WEIGHT }} {{ item.WEIGHT_UNITS }} <br></span></span>
                      <span v-if="item.DISTANCE>0">DISTANCE : <span style="color:dodgerblue;font-weight:bold">{{ item.DISTANCE }} {{ item.DISTANCE_UNITS }} <br></span></span>
                      <span v-if="item.AREA>0">AREA : <span style="color:dodgerblue;font-weight:bold">{{ item.AREA }} {{ item.AREA_UNITS }} <br></span></span>
                      <span v-if="item.VOLUME>0">VOLUME : <span style="color:dodgerblue;font-weight:bold">{{ item.VOLUME }} {{ item.VOLUME_UNITS }} <br></span></span>
                    </div>
                  </div>    
                </div>
                    
                    
                <div class=" col-md-4">
                  <div
                    class="image-container img-raised img-radius city text-left"
                    style="min-height:120px"
                    @click="moveToLocation(MC2.lnglat,MC2.title)"
                  >
                    <h5 class="mb-2 font-weight-bold text-uppercase">
                      REFERENCE
                    </h5>
                    <div class="">
                      <div
v-for="item in trace"
:key="item.TRACE_NUMBER || item.DESC || i"
>
                        <b>{{ item.DESC }}</b> : <span style="color:dodgerblue;font-weight:bold">{{ item.TRACE_NUMBER }} </span>
                        <hr>
                      </div> 
                    </div>
                  </div>    
                </div>
                    
                <div class="col-md-4">
                  <div
                    class="image-container img-raised img-radius city text-left"
                    style="min-height:120px"
                  >
                    <h5 class="mb-2 font-weight-bold text-uppercase">
                      STATUS
                    </h5>                                             
                    <div
v-for="item in status"
:key="item.CHANGED + '-' + item.STATUS_CODE || i"
>
                      <b>{{ item.CHANGED }}</b> : <small>[{{ item.STATUS_CODE }}]</small> <br> <b> <span style="color:dodgerblue">{{ item.SHORT_DESCRIPTION }}</span> <span v-if="item.STAT_COMMENT"><br><small>"{{ item.STAT_COMMENT }}"</small></span></b>
                      <hr>
                    </div>                            
                  </div>    
                </div>
              </div>              
            </div>    
          </div>
          <div class="row">
            <div class="content-center col-md-8  ml-auto mr-auto ">                         
              <div
v-for="p in pod"
:key="p.doc_id"
>
                <div v-if="p.public_url">
                  <hr>
                  {{ p.title }} <br>
                  <a
:href="p.public_url"
target="_blank"
> <img :src="p.thumbnail_path"> </a>
                  <hr>
                </div>
              </div>             
            </div>
          </div>            
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Bookingstatus',
     
  data() {
    return { 
    debug: null,  
    encryptedFB: '',
    fb: null,
    status: null,
    trace: null,
    tldtl: null,
    pod: null
   };
  },
  watch: {      
  },
  created() {        
    
  },  
  updated(){

  },
  mounted (){
    this.fb = this.$route.query.BN
    this.encryptedFB = this.$route.query.FB
    if (this.encryptedFB)this.getEncryptedFB(this.encryptedFB)
    if (this.fb)this.getFB(this.fb)
  },
  methods: {
    reset (){
        this.encryptedFB = null,
        this.fb = null,
        this.status = null,
        this.trace = null,
        this.pod = null
    },    
    getEncryptedFB (fb){    
        let vm = this                
        axios.get('https://api.transplus.com/FreightBill/' + fb )
        .then((response) => {
          vm.debug = response.data
          vm.fb =  response.data.fb[0]                          
          vm.status = response.data.status
          vm.trace = response.data.trace
          vm.tldtl = response.data.tldtl
          vm.pod = response.data.pod
        })
        .catch(e => {
          console.log(e)
        })                
    },
    getFB (fb){    
        let vm = this                
        axios.get('https://api.transplus.com/BillNumber/' + fb )
        .then((response) => {
          vm.debug = response.data
          vm.fb =  response.data.fb[0]                          
          vm.status = response.data.status
          vm.trace = response.data.trace
          vm.tldtl = response.data.tldtl
          vm.pod = response.data.pod
        })
        .catch(e => {
          console.log(e)
        })                
    }         
  }
}
</script>

<style scoped>
  .custom_form {    
    border:1px solid #333;
    width: 100%;
    padding: 12px 20px;
    margin-bottom: 8px;
    font-size:2em;
    text-transform: uppercase;
  }

  .custom_form:focus {
      outline: none !important;
      border:1px solid #55B550;
      box-shadow: 0 0 4px #55B550;
  }
  .hoverblue {
  color: #999;
  background-color: rgb(245, 245, 245);
  border-width: 0;
  font-weight: bold;
  font-size: 2em;    
  margin: 20px 1px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.hoverblue:hover{
  color: white;
  background-color: dodgerblue;
}
</style>